#import "./VariantFragment.gql"
#import "./productCardHeaderFragment.gql"
#import "./productAccordionFragment.gql"
#import "./productTestimonialFragment.gql"
#import "./productVideoFragment.gql"
#import "./productFlagsFragment.gql"
#import "./productOptionSwatchesFragment.gql"
#import "./productBadgesFragment.gql"
#import "./productRelatedProductsFragment.gql"
#import "./productKeyFeaturesFragment.gql"
#import "./productBundleProductFragment.gql"
#import "./productComparisonFragment.gql"
#import "./productDigitalAddOnFragment.gql"
#import "./digitalProductTypeFragment.gql"
#import "./subtitleFragment.gql"
#import "./imageMetadataFragment.gql"

fragment productPageProductFragment on Product {
  id
  handle
  availableForSale
  descriptionHtml
  productType
  title
  tags

  options {
    name
    values
  }
  images(first: 99) {
    edges {
      node {
        id
        src: originalSrc
        altText
        width
        height
      }
    }
  }
  variants(first: 99) {
    edges {
      node {
        ...VariantFragment
      }
    }
  }
  ...productCardHeaderFragment
  ...productAccordionFragment
  ...productTestimonialFragment
  ...productVideoFragment
  ...productFlagsFragment
  ...productOptionSwatchesFragment
  ...productBadgesFragment
  ...productRelatedProductsFragment
  ...productKeyFeaturesFragment
  ...productBundleProductFragment
  ...productComparisonFragment
  ...productDigitalAddOnFragment
  ...digitalProductTypeFragment
  ...imageMetadataFragment
  ...subtitleFragment
}
